import { ReactComponent as CheckWhiteIcon } from "assets/images/iconsV2/check-white.svg";

import "./ApprovalTimeline.scss";

type ApprovalTimelineProps = {
  title: string;
  variant?: "inactive" | "active" | "completed";
  showLine?: boolean;
  date?: string;
  children?: React.ReactNode;
};

function ApprovalTimeline(props: ApprovalTimelineProps) {
  const { title, date, children, showLine, variant } = props;

  return (
    <div className="approval-timeline">
      <div
        className={`approval-timeline__step-container ${showLine ? "line" : ""} ${variant === "completed" ? "active" : ""}`}
      >
        <div className={`approval-timeline__step--${variant}`}>{variant === "completed" && <CheckWhiteIcon />}</div>
      </div>
      <div className="w-100">
        <div className="d-flex justify-content-between align-items-center flex-fill mb-sm">
          <div className="text-sm text-primary font-medium">{title}</div>
          {date && <div className="text-xs text-quaternary">{date}</div>}
        </div>
        <div>{children}</div>
      </div>
    </div>
  );
}

export default ApprovalTimeline;

ApprovalTimeline.defaultProps = {
  children: null,
  date: null,
  showLine: true,
  variant: "inactive",
};
